import { GET_PARENT_SUCCESS} from 'constants/index'

export default (state = {}, action) => {
    switch(action.type){
        case GET_PARENT_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}